<template>
  <div>
    <v-container>
       <v-row>
        <v-col cols='12' md='4'>
          <vehicle-basics
            v-if='item'
            :item='item'
            @update='update'
          ></vehicle-basics>
        </v-col>
        <v-col cols='12' md='4'>
          <vehicle-details 
            v-if='item'
            :item='item'
            @update='update'
          ></vehicle-details>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import Basics from './Basics'
import Details from './Details'

export default {
  name: 'vehicle-overview',
  props: {
    item: {
      required: true
    }
  },
  components: {
    'vehicle-basics': Basics,
    'vehicle-details': Details
  },
  methods: {
    update (item) {
      this.$emit('update', item)
    },
  }
}
</script>
